import { useMemo } from "react";

export const useDoubleLineChartConfig = (
  data: any,
  getColor: ({ type }: { type: string }) => void,
  isAmount?: boolean,
) => {
  const config: any = useMemo(
    () => ({
      data,
      padding: "auto" as const,
      xField: "month",
      yField: "value",
      height: 300,
      seriesField: "type",
      slider: undefined,
      color: getColor,
      legend: false,
      tooltip: {
        customContent: (_: any, data: any) => {
          if (data.length > 0) {
            const mainKey: number = data[0].data.isMain ? 0 : 1;
            const secondaryKey: number = mainKey ? 0 : 1;

            return `<div class="py-2 area-tooltip"><div class="text-sm w-400 pb-1">${
              data[0].data.tooltipValue
            }</div><div class="d-flex justify-space-between"><div class="d-flex align-center"><div class="mr-1 legend small all"></div><div class="text-sm">${
              data[mainKey].data.type
            }:</div></div><div class="text-sm w-500">${isAmount ? "$" : ""}${data[mainKey].data.value.toLocaleString()}${isAmount ? "k" : ""}</div></div><div class="d-flex justify-space-between"><div class="d-flex align-center"><div class="mr-1 legend small"></div><div class="text-sm">${
              data[secondaryKey].data.type
            }:</div></div><div class="text-sm w-500">${isAmount ? "$" : ""}${data[secondaryKey].data.value.toLocaleString()}${isAmount ? "K" : ""}</div></div></div>`;
          }

          return "";
        },
      },
    }),
    [data, getColor, isAmount],
  );

  return { config };
};
